(function () {
  /*
   * Shopify Forms paints the footer fields inside an open shadow root.
   * Theme CSS can size the host, but the inner grid stays at the input's
   * default width. This sheet stretches that column on phone and desktop.
   * The 2px container margin is removed so width 100% does not spill out.
   */
  var sheet = [
    ':host > div > div {',
    '  grid-template-columns: minmax(0, 1fr) !important;',
    '  justify-content: stretch !important;',
    '}',
    'section > section {',
    '  margin: 0 !important;',
    '  width: 100% !important;',
    '  max-width: none !important;',
    '}',
    'input, button {',
    '  width: 100% !important;',
    '  max-width: none !important;',
    '  box-sizing: border-box !important;',
    '}',
  ].join('\n');

  function paint(host) {
    var root = host.shadowRoot;
    if (!root || root.getElementById('custom-footer-newsletter')) return;
    var style = document.createElement('style');
    style.id = 'custom-footer-newsletter';
    style.textContent = sheet;
    root.appendChild(style);
  }

  function boot() {
    document.querySelectorAll('.shopify-section-group-footer-group shopify-forms-embed').forEach(paint);
  }

  boot();
  document.addEventListener('shopify:section:load', boot);

  var tries = 0;
  var timer = window.setInterval(function () {
    boot();
    tries += 1;
    if (tries >= 20) window.clearInterval(timer);
  }, 250);
})();
